import { DataTable, Heading, Loader } from "@/components";
import { Button, Input } from "@/components/ui";
import { Search } from "lucide-react";
import useIncidentMgmt from "./useIncidentMgmt";

const IncidentMgmt = () => {
  const {
    communityDetail,
    isMobile,
    globalFilter,
    setGlobalFilter,
    onAddIncident,
    columns,
    onRowClick,
    setPageNumber,
    setPageSize,
    pageNumber,
    pageSize,
    sorting,
    setSorting,
    incidentList,
    isIncidentLoading,
    isIncidentRefetching,
    hasAddPermission
  } = useIncidentMgmt();

  return (
    <div className="p-4 md:p-6">
      {/* Header & Search */}
      <div className="flex flex-col xl:flex-row gap-2 xl:items-center xl:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <Heading
            title={`Incident Management - ${(communityDetail as any)?.name}`}
          />
          {isMobile && hasAddPermission && (
            <Button onClick={onAddIncident} className="px-2">
              + Add Incident
            </Button>
          )}
        </div>
        <div className="flex flex-row items-center gap-4">
          <Input
            type="text"
            placeholder="Search"
            value={globalFilter ?? ""}
            onChange={(e) => setGlobalFilter(e.target.value)}
            className="w-full sm:w-72 bg-white h-[40px]"
            startIcon={<Search className="w-4 h-4" />}
          />
          {!isMobile && hasAddPermission && <Button onClick={onAddIncident}>+ Add Incident</Button>}
        </div>
      </div>

      {/* Responsive Table */}
      {isIncidentLoading || isIncidentRefetching ? (
        <Loader />
      ) : (
        <>
          <DataTable
            columns={columns}
            data={(incidentList?.data || [])?.sort(
              (a: any, b: any) =>
                new Date(b.updatedAt).getTime() -
                new Date(a.updatedAt).getTime()
            )}
            setGlobalFilter={setGlobalFilter}
            globalFilter={globalFilter}
            onRowClick={onRowClick}
            setPageNumber={setPageNumber}
            setPageSize={setPageSize}
            pageNumber={pageNumber}
            pageSize={pageSize}
            totalPages={Math.ceil(incidentList?.total / pageSize)}
            totalRecords={incidentList?.total}
            serverSidePagination={true}
            sorting={sorting}
            onSortingChange={setSorting}
          />
        </>
      )}
    </div>
  );
};

export default IncidentMgmt;
